const rules = {
	user: {
		static: [
			"contact-sources:view",
		],
	},

	admin: {
		static: [
			"dashboard:view",
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"contacts-page:deleteContact",
			"connections-page:actionButtons",
			"connections-page:addConnection",
			"connections-page:editOrDeleteConnection",
			"tickets-manager:closeAll",
			"contact-sources:view",
			"contact-sources:create",
			"contact-sources:edit",
			"contact-sources:delete",
		],
	},
};

export default rules;
